var map = {
	"./Group 22302.png": 1317,
	"./avatar-christmas.webp": 1318,
	"./bottom-bg-christmas.webp": 1319,
	"./btn-active.png": 1320,
	"./content-deco-1.webp": 1321,
	"./content-deco-2.webp": 1322,
	"./content-deco-3.webp": 1323,
	"./content-deco-4.webp": 1324,
	"./deco-3.webp": 1325,
	"./deposit-icon.webp": 1326,
	"./home-icon-active.webp": 1327,
	"./home-icon.webp": 1328,
	"./live-icon-active.webp": 1329,
	"./live-icon.webp": 1330,
	"./master-bg.jpg": 1331,
	"./me-icon-active.webp": 1332,
	"./me-icon.webp": 1333,
	"./platform.png": 1334,
	"./platform.webp": 1335,
	"./promos-icon-active.webp": 1336,
	"./promos-icon.webp": 1337,
	"./promos.webp": 1338,
	"./service-christmas.webp": 1339,
	"./snowman.webp": 1340,
	"./sponsor-icon-active.webp": 1341,
	"./sponsor-icon.webp": 1342,
	"./title-deco-left.webp": 1343,
	"./title-deco-right.webp": 1344,
	"./tree.webp": 1345,
	"./vip-icon.webp": 1346,
	"./vip.webp": 1347,
	"./withdraw-icon.webp": 1348,
	"./wwr-img.webp": 1349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;